module.exports = __webpack_public_path__ + "static/flynn-logo-87c1be701a5b70a1abfab28cf744afea.svg";